/**
 * Asset availability DTO
 */
export class AssetAvailabilityDto {
	/**
	 * Asset uuid
	 */
	assetUuid!: string;

	/**
	 * Is asset available
	 */
	isAvailable!: boolean;

	/**
	 * Asset's next available from date
	 */
	nextAvailableFrom?: Date;

	/**
	 * Asset's next available to date
	 */
	nextAvailableTo?: Date;
}
